import { FunctionComponent, useEffect, useState } from "react";
import { HangarChecklistDto } from "../../types/checklist";
import { Button, Checkbox, Snackbar, Dialog, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { ChecklistTaskDto } from "../../types/checklist";
import ChecklistApi from "../../api/checklists";
import { Check } from '../../components/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';

type ChecklistDetailsModalProps = {
    checklist: HangarChecklistDto | undefined;
    checkListDialogOpen: Function;
    isChecklistAdmin: boolean;
    refreshChecklists: Function;
    setLoading: Function;
    loading: boolean;
}

const ChecklistDetailsModal: FunctionComponent<ChecklistDetailsModalProps> = ({ checklist, checkListDialogOpen, isChecklistAdmin, refreshChecklists, setLoading, loading }) => {
    const store = useSelector((state: RootState) => state);
	const allEmployees = store.employees.all_employees;

    const [tasks, setTasks] = useState<ChecklistTaskDto[]>([]);
    const [checklistStatus, setChecklistStatus] = useState<boolean>(false);
    const [closeChecklistDialogOpen, setChecklistDialogOpen] = useState<boolean>(false);
    const [snackbarMessage, setSnackbarMessage] = useState<string>("");

    useEffect(() => {
        setLoading(true);
        refresh();
    }, [checklist]);

    const refresh = () => {
        if (checklist !== undefined) {
            setChecklistStatus(checklist?.IsActive);
            ChecklistApi.GetChecklistsTasks(checklist.Id).then(res => {
                setTasks(res.data);
                setLoading(false);
            });
        }
    }
    const checkOffTask = (task: ChecklistTaskDto) => {
        setLoading(true);
        ChecklistApi.UpdateChecklistTask(task.Id, !task.IsDone, true).then(res => {
            refresh();
        });
    }

    const checkOffAsNotApplicableTask = (task: ChecklistTaskDto) => {
        setLoading(true);   
        ChecklistApi.UpdateChecklistTask(task.Id, task.IsDone, !task.IsApplicable).then(res => {
            refresh();
        });
    }

    const generateTableBody = (row: ChecklistTaskDto, index: number) => {
        const lastModifiedByEmployee = allEmployees.find((employee) => employee.Id === row.LastModifiedByEmployeeId)?.userName.split('@')[0];	
        return (
            <TableRow key={index}>
                <TableCell>{row.TaskName}</TableCell>
                {(isChecklistAdmin && checklist?.IsActive) ?
                    <TableCell>
                        <Checkbox
                            checked={!row.IsApplicable}
                            onChange={() => checkOffAsNotApplicableTask(row)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </TableCell> :
                    <TableCell>{row.IsApplicable === false ? <Check color="success" /> : ""}</TableCell>
                }
                {(isChecklistAdmin && checklist?.IsActive) ?
                    <TableCell>
                        {row.IsApplicable === true &&
                        <Checkbox
                            checked={row.IsDone}
                            onChange={() => checkOffTask(row)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                    </TableCell> :
                    <TableCell>{row.IsDone === true ? <Check color="success" /> : ""}</TableCell>
                }
                  <TableCell className="w-1/5">{lastModifiedByEmployee}</TableCell>
            </TableRow>
        );
    }

    const onCloseChecklist = () => {
        if (checklist !== undefined) {
            setLoading(true);
            ChecklistApi.InactiateChecklist(checklist.Id).then(res => {
                if (res.status === true) {
                    setChecklistStatus(!checklistStatus);
                    checkListDialogOpen(false);
                    refreshChecklists();
                    setLoading(false);
                }
            });
        }
    }
    
    const onFinishedChecklist = () => {
        const allApplicableAreDone = tasks.filter(task => task.IsApplicable).every(task => task.IsDone === true);

        if (allApplicableAreDone) {
          setChecklistDialogOpen(true);
        } else {
            setSnackbarMessage("Not all applicable tasks are done yet!");
        }
      };

    return (
        <div>
            {(isChecklistAdmin && checklist?.IsActive) &&
                <div className="flex flex-wrap">
                    <Button
                        onClick={() => onFinishedChecklist()}
                        variant='contained'
                        color={'primary'}
                        className="mt-4"
                    >
                        Finish Checklist
                    </Button>
                </div>
            }
            <Table
                headers={["Task Name", "N/A", "Done", "Last Modified By"]}
                rows={tasks}
                generateBody={(row: ChecklistTaskDto, index: number) => generateTableBody(row, index)}
                pagination={true}
                defaultRowsPerPage={10}
                skipIndexCol={true}
                loading={loading === true ? true : (tasks.length === 0 ? true : false)}
            />
            <Dialog
                visible={closeChecklistDialogOpen}
                max_width={"sm"}
                title={"Are you sure you want to close this checklist?"}
                context={<></>}
                onClose={(status: Boolean) => { status === true ? onCloseChecklist() : setChecklistDialogOpen(false) }}
                strict={false}
                show_options={true}
            />
            <Snackbar
                onSnackBarClose={() => setSnackbarMessage("")}
                open={snackbarMessage.length > 0}
                message={snackbarMessage}
                autoHide={true}
                horizontalPosition='right'
                severity={"warning"}
            >
            </Snackbar>
        </div>
    );
}
export default ChecklistDetailsModal;